module.exports = __webpack_public_path__ + "7900cfe4c7b475f7d081a27db07c5a58.jpg";